import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AccessRequest} from '../models/access-request';

@Component({
  selector: 'access-request-list',
  template: `
    <div class="row header">
      <div class="col-md-2">Last Name</div>
      <div class="col-md-1">First Name</div>
      <div class="col-md-2">Company Name</div>
      <div class="col-md-2">Email Address</div>
      <div class="col-md-2">Telephone</div>
      <div class="col-md-1">Status</div>
      <div class="col-md-2">&nbsp;</div>
    </div>
    <div class="row line-item" *ngFor="let r of requests">
      <div class="col-md-2">{{r.lastname}}</div>
      <div class="col-md-1">{{r.firstname}}</div>
      <div class="col-md-2">{{r.company}}</div>
      <div class="col-md-2">{{r.email}}</div>
      <div class="col-md-2">{{r.phone}}</div>
      <div class="col-md-1 text-center">
        <span *ngIf="r.denied">DENIED</span>
        <span *ngIf="r.granted">GRANTED</span>
        <span *ngIf="!r.denied && !r.granted">PENDING</span>
      </div>
      <div class="col-md-2 text-right">
        <a class="action-link" *ngIf="!r.granted && !r.denied" 
                (click)="approve(r)">
          <i class="fa fa-thumbs-up"></i>
          <span *ngIf="approveId === r.id">Approving</span>
          <span *ngIf="approveId !== r.id">Approve</span>
        </a>
        <a class="action-link red" *ngIf="!r.denied && !r.granted"
                (click)="deny(r)">
          <i class="fa fa-ban"></i>
          <span *ngIf="denyId === r.id">Declining</span>
          <span *ngIf="denyId !== r.id">Decline</span>
        </a>
      </div>
    </div>
  `,
  styles: [`
    .header {
      margin-bottom: 5px;
      border-bottom: 1px solid #666;
      font-weight:bold;
    }
    .line-item {
      border-bottom: 1px solid #ccc;
      margin-bottom:3px;
      padding-bottom:3px;
    }
    .action-link {
      margin-left: 10px;
    }
    .red {
      color: darkred!important;
    }
  `]
})
export class AccessRequestListComponent {
  @Input() requests: AccessRequest[];
  @Input() approveId: number;
  @Input() denyId: number;
  @Output() approveRequest: EventEmitter<AccessRequest> = new EventEmitter();
  @Output() denyRequest: EventEmitter<AccessRequest> = new EventEmitter();

  approve(req: AccessRequest) {
    const request = Object.assign({}, req);
    request.granted = true;
    this.approveRequest.emit(request);
  }

  deny(req: AccessRequest) {
    const request = Object.assign({}, req);
    request.denied = true;
    this.denyRequest.emit(request);
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/components/access-request-list.ts